import React, { useEffect } from 'react';

import { Container } from '../../../../../symphony';

import {
	ActionType,
	IMaterialProps,
	RequestType,
} from '../../../global-interface';
import { SlLEContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { SlAIChatPlayground } from '../../../../../aIChatPlayground/public/SlAIChatPlayground';
import { IMaterialInfo, IMaterialSolutionSubmission, IMaterialStatus } from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';
import { useContainerData } from '../../../../../shared/public/SlHooks/useContainerData';
import { SlDataService } from '../../../services/sl-data.service';

export function AIChatPlayground({ materialInfo }: IMaterialProps): JSX.Element {
	const { actions$ } = Container.take(SlLEContext, SlActions);
	const { lessonSessionGuId$: lessonSessionGuId, loading$: loading } = useContainerData(SlLEContext, SlDataService, ['lessonSessionGuId$', 'loading$']);

	const solveMaterialCallback = (
		statusChanges: IMaterialStatus[],
		solutions: IMaterialSolutionSubmission[],
		materialInfo?: IMaterialInfo,
	): void => {
		actions$.next({
			type: ActionType.SolveMaterialCallback,
			requestType: RequestType.Parallel,
			data: {
				statusChanges,
				solutions,
				materialInfo,
			},
		});
	};

	useEffect(() => {
		actions$.next({
			type: ActionType.OnTheoryMount,
			requestType: RequestType.Parallel,
			data: {
				materialInfo,
			},
		});
	}, []);

	if (!materialInfo.chat && loading.isAIChatSettingsLoading) {
		return null;
	}

	return (
		<SlAIChatPlayground data={materialInfo} solveMaterialCallback={solveMaterialCallback} lessonSessionGuId={lessonSessionGuId} />
	);
}
